var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"duplicate-segment"},[[_c('v-list-item',{attrs:{"disabled":_vm.disabled}},[_c('v-list-item-title',{staticClass:"duplicate",on:{"click":function($event){_vm.value = true}}},[_vm._v("Duplicar")])],1)],_c('v-dialog',{attrs:{"value":_vm.value,"width":"480px","persistent":""}},[_c('v-card',{staticClass:"pa-2"},[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Qual será o nome do novo segmento?")])]),_c('v-card-text',[_c('v-text-field',{model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_c('mf-action-buttons',{staticClass:"mt-2",attrs:{"primary-button":{
            text: 'Criar',
            action: _vm.createInstantSegment,
            isVisible: true,
            isLoading: _vm.$wait.is('clone-segment'),
            isDisabled: _vm.isEmptyName,
          },"extra-button":{
            text: 'Cancelar',
            action: _vm.closeDialog,
            isVisible: true,
          }}})],1)],1)],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }